import Image from "next/image";
import style from "./loader.module.scss";

interface LoaderProps {
  text?: string;
  classes?: string[];
 }

export const Loader = ({ text, classes = [] }: LoaderProps) => {

  return (
    <div className={`${style.spinnerWrapper} ${classes.join(' ')}`}>
      <div className={style.spinner}>
        {/* <Image src={'/img/loader.gif'} width={200} height={200} alt="loader" /> */}
      </div>
      {
        text?.length ?
        <div className={style.text}>
          {text}
        </div>
        : 
        <></>
      }
    </div>
  );
};

export default Loader;
